import { checkAccessRights } from '@/modules'
import { useSelector } from 'react-redux'

const useCheckAccessRights = (userRight: string[] | string): boolean => {
  const userInfo = useSelector(state => state.user.info)
  return checkAccessRights(userRight, userInfo)
}

export default useCheckAccessRights
